// React
import React from 'react'
// Components
import Button from './Button'

export default class Modal extends React.Component {

	constructor(props) {
		super(props)
		this.state = { modalClass: 'capps-modal-bg hidden' }
	}

	componentWillMount() {
		if (this.props.status === 'visible') {
			this.setState({ modalClass: 'capps-modal-bg' })
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.status !== this.props.status) {
			this.setState({ modalClass: this.props.status === 'visible' ? 'capps-modal-bg' : 'capps-modal-bg hidden' })
		}
	}

	render() {
		// Standard modal props
		const { title, text, action, cancel, loading } = this.props
		return (
			<div className={this.state.modalClass}>
				<div className='capps-modal'>
					{title &&
						<div>
							<div className='capps-header'>{title}</div>
							<div className='capps-height-20' />
						</div>}
					{loading && <center><div className='capps-moon' /></center>}
					{text &&
						<div>
							<div className='capps-text'>{text}</div>
							<div className='capps-height-20' />
						</div>}
					{action.text &&
						<Button
							action={() => action.func()}
							text={action.text}
						/>}
					{cancel.text &&
						<Button
							action={() => cancel.func()}
							flat={true}
							text={cancel.text}
						/>}
				</div>
			</div>
		)
	}

}



// WEBPACK FOOTER //
// ./src/Components/Display/Modal.js